/* eslint-disable no-console */
import _reduce from 'lodash/reduce';
import { useEffect, useState } from 'react';
import { Dataset, NectedSuggestionModel } from 'ui';

import { getDatasetWithoutReactCode } from '../../Rules/utils/common';
import { useWorker } from '../workers/useWorker';

type UseGenerateDatasetArgs = {
  updatedDataset: Record<string, Dataset>;
  showEncryptedVariables?: boolean;
};

export function useGenerateDataset({
  updatedDataset,
  showEncryptedVariables = false,
}: UseGenerateDatasetArgs) {
  const [tokens, setTokens] = useState<NectedSuggestionModel[]>([]);
  const { workerApi } = useWorker();

  useEffect(() => {
    // In some cases Tooltip and footer is present which are not cloned by the worker
    // internally and are not used for token generation so ignoring them here
    const dataset = _reduce(
      updatedDataset,
      (finalDataset, currDataset, key) => {
        return {
          ...finalDataset,
          [key]: {
            id: currDataset.id,
            name: currDataset.name,
            attributes: currDataset.attributes,
            blockName : currDataset.blockName
          },
        };
      },
      {}
    );

    const filteredDataset = filterFieldsFromDS({...dataset})
    const timezoneOptions = {
      timezone : window.sessionStorage.getItem('nected-tz'),
      dateFormat : window.sessionStorage.getItem('nected-df')
    }
    workerApi
      .getDataSetSuggestionsObjV2Worker(showEncryptedVariables , timezoneOptions , filterFieldsFromDS(filteredDataset))
      .then((res: NectedSuggestionModel[]) => {
        setTokens(res);
      });
  }, [JSON.stringify(getDatasetWithoutReactCode(updatedDataset))]);


  return {
    tokens,
  };
}

/**
 * This will filter fields key from executed value of Gsheet node. 
 * @param dataset 
 * @returns 
 */
export const filterFieldsFromDS = (dataset: Record<string, Dataset>): Record<string, Dataset> => {
  const updatedDataset = {...dataset};
  
  Object.keys(updatedDataset).forEach(blockKey => {
    const block = updatedDataset[blockKey];
    
    if (block.blockName === 'gsheet') {
      if (block.attributes?.output?.executedValue?.fields) {
        delete block.attributes.output.executedValue.fields;
      }
    }
  });
  
  return updatedDataset;
};